import {
  createSummaryCardsConfig,
  createDataGridConfig,
} from '../email-pulse-config-defaults';
import { EMAIL_PULSE_DEFINITIONS } from '../email-pulse-definitions/email-pulse-definitions';

/**
 * Configuration for Security tab summary cards
 */
export const securitySummaryCardsConfig = createSummaryCardsConfig(
  'securitySummary',
  'SecuritySummaryCards',
);

/**
 * Configuration for Security tab data grid
 */
const securityGrid = createDataGridConfig(
  'emailTypeDisplay',
  EMAIL_PULSE_DEFINITIONS.emailTypeDisplay,
);
export const getSecurityDataGridColumns = securityGrid.getColumns;
export const securityColumnVisibilityModel = securityGrid.columnVisibilityModel;
